export const IN_PRODUCTION = 'In Production (Available Soon)'
export const SELECTED = 'Selected'
export const NOT_ENROLLABLE = 'Not Enrollable'
export const COMPLETED = 'Completed'
export const COMPLETED_NOT_REPEATABLE = 'Completed - not repeatable'
export const ENROLLED = 'Enrolled'
export const HAS_PRE_REQUISITE = 'Must pass prerequisite to enroll'
export const PREPARE_CALCULUS = 'Prepare for Calculus I'
export const DASHBOARD_COURSE_HIDDEN = 'dashboard-course-hidden'
